import type { SectionProps } from '@/components/sitemap/Section';
import { sharedConfig } from '@/pageConfig/shared';
import sections from '@/static/sitemap.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  section: SectionProps[];
}

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    ...sharedConfig['fr-FR'].seo,
    title: "Parcourez le site Lemonade France | Trouvez toutes les pages et informations sur l'assurance habitation",
    metaTitle:
      "Parcourez le site Lemonade France | Trouvez toutes les pages et informations sur l'assurance habitation",
    description:
      'Parcourez le site Lemonade France pour trouver rapidement toutes les pages utiles concernant nos assurances habitation et nos services.',
  },
  section: sections['fr-FR'],
};
